import React from "react";
import styles from './styles.module.css';
import {Container, FeatureTitle} from "../../../components";

const MediumSizeComponent = ({city}) => {
	return (
		<div className={styles.medium}>
			<img src={city.image} width="100% !important" height="auto !important" alt={"City"}/>
			<div className={styles.bottomLeft}>
				<p >{city.title}</p>
				<button className={styles.button}>View Holidays</button>
			</div>

		</div>
	)
};
const SmallSizeComponent = ({city}) => {
	return (
		<div className={styles.medium}>
			<img src={city.image} width="100% !important" height="auto !important" alt={"City"}/>
			<div className={styles.bottomLeft}>
				<p>{city.title}</p>
				<button className={styles.button}>View Holidays</button>
			</div>

		</div>
	)
};

const TrendingTrips = () => {
	const trendingData = [
		{
			image : './assets/images/mekke-2.jpg',
			title: "Makkah"
		},
		{
			image : './assets/images/medina-2.jpg',
			title: "Medinah"
		},
		{
			image : './assets/images/paris.jpg',
			title: "Paris"
		},
		{
			image : './assets/images/london.jpg',
			title: "London"
		},
		{
			image : './assets/images/venice.jpg',
			title: "Venice"
		},
		{
			image : './assets/images/dubai-2.jpg',
			title: "Dubai"
		}
	]
	return (
		<Container>
			<FeatureTitle title={"Trending Trips"} description={"Chosen by our happy customers"} />
			<div className={styles.flexContainer}>
				<MediumSizeComponent city={trendingData[1]}/>
				<MediumSizeComponent city={trendingData[4]}/>
			</div>
			<div className={styles.flexContainer}>
				<SmallSizeComponent city={trendingData[0]}/>
				<SmallSizeComponent city={trendingData[2]}/>
				<SmallSizeComponent city={trendingData[3]}/>
				<SmallSizeComponent city={trendingData[5]}/>
			</div>
		</Container>
	)
};
export default TrendingTrips;